import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import { List } from 'immutable';
import CurrentOrganizationIdStore from './CurrentOrganizationIdStore';
import TableauUsersByOrganizationStore from './TableauUsersByOrganizationStore';


class AvailableTableauUsersStore extends ReduceStore {
  getInitialState() {
    return new List();
  }

  reduce(state) {
    this.getDispatcher().waitFor([
      CurrentOrganizationIdStore.getDispatchToken(),
      TableauUsersByOrganizationStore.getDispatchToken()]);
    if (CurrentOrganizationIdStore.hasChanged() ||
        TableauUsersByOrganizationStore.hasChanged()) {
      return TableauUsersByOrganizationStore.getTableauUsersForOrganization(
        CurrentOrganizationIdStore.getState());
    }

    return state;
  }
}

const instance = new AvailableTableauUsersStore(AppDispatcher);
export default instance;
